import { Component } from '@angular/core';
import { CapiLoginService } from "../../core/extension/login/capi-login-service";
import { TranslateService } from "@ngx-translate/core";
import { keysToTranslate } from "../../../i18n/keys-to-translate";
import { Router } from "@angular/router";

@Component({
  selector: 'cap-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  title: string;
  appName: string

  constructor(private loginService: CapiLoginService,
              private translateService: TranslateService,
              private router: Router) {
    keysToTranslate<string>([
      'successfullyLoggedOut',
      'backToIntercapi'
    ]);
    this.title = this.translateService.instant('successfullyLoggedOut');
  }

  getAppTitle(): string {
    return this.translateService.instant('layouts.page.title');
  }

  getIntercapiBezeichnung(): string {
    return this.appName = this.translateService.instant("backToIntercapi",
      {"name": this.getAppTitle()});
  }

  redirectToHome() {
    this.router.navigate(['/ui']);
  }

}
